export default __webpack_public_path__ + "static/media/addcard.d299145e.svg";